import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import tokenReducer from './slices/tokenSlice';
import analyticsReducer from './slices/analyticsSlice';
import marketplaceReducer from './slices/marketplaceSlice';
import itoReducer from './slices/itoSlice';
import poolReducer from './slices/poolSlice';
import postReducer from './slices/postSlice';
import discoveryReducer from './slices/discoverySlice';
import messagesReducer from './slices/messagesSlice';
import adminReducer from './slices/adminSlice';
import notificationsReducer from './slices/notificationsSlice';
import profileReducer from './slices/profileSlice';
import chatReducer from './slices/chatSlice';
import achievementReducer from './slices/achievementSlice';
import agentReducer from './slices/agentSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    token: tokenReducer,
    analytics: analyticsReducer,
    marketplace: marketplaceReducer,
    ito: itoReducer,
    pool: poolReducer,
    post: postReducer,
    discovery: discoveryReducer,
    messages: messagesReducer,
    admin: adminReducer,
    notifications: notificationsReducer,
    profile: profileReducer,
    chat: chatReducer,
    achievement: achievementReducer,
    agent: agentReducer,
  },
  devTools: import.meta.env.MODE !== 'production',
});

export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
